import { render, staticRenderFns } from "./realCosts.vue?vue&type=template&id=f488a142&scoped=true"
import script from "./realCosts.vue?vue&type=script&lang=js"
export * from "./realCosts.vue?vue&type=script&lang=js"
import style0 from "./realCosts.vue?vue&type=style&index=0&id=f488a142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488a142",
  null
  
)

export default component.exports